/**
 * Cart API service
 * @module features/cart/cartService
 */

import api from '../../app/axios';

const getCart = async () => {
  const response = await api.get('/cart');
  return response.data;
};

const addToCart = async (productId, variantId, quantity) => {
  const response = await api.post('/cart', { productId, variantId, quantity });
  return response.data;
};

const updateCartItem = async (itemId, quantity) => {
  const response = await api.put(`/cart/${itemId}`, { quantity });
  return response.data;
};

const removeFromCart = async (itemId) => {
  const response = await api.delete(`/cart/${itemId}`);
  return response.data;
};

const clearCart = async () => {
  const response = await api.delete('/cart');
  return response.data;
};

const cartService = { getCart, addToCart, updateCartItem, removeFromCart, clearCart };
export default cartService;

// Developed and Designed by Trophy Developers
